export const MENU_QR_BASE_URL = 'https://bistri.fi/go';

export interface IMenuQrUrlInput {
  restaurantId: number;
  branchToken?: string | null;
  tableToken?: string | null;
  takeAway?: boolean;
}

/**
 * Builds the URL encoded in a menu QR. The take-away flag is emitted as `ta=1`
 * (a bare `ta` is parsed as null by vue-router and ignored by the customer app);
 * `ref=qr` is always the last parameter.
 */
export function buildMenuQrUrl(input: IMenuQrUrlInput): string {
  const query: string[] = [];

  if (input.branchToken) {
    query.push(`b=${encodeURIComponent(input.branchToken)}`);
  }

  if (input.tableToken) {
    query.push(`t=${encodeURIComponent(input.tableToken)}`);
  }

  if (input.takeAway) {
    query.push('ta=1');
  }

  query.push('ref=qr');

  return `${MENU_QR_BASE_URL}/${input.restaurantId}?${query.join('&')}`;
}
